import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newLine'
})
export class NewLinePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (!value || !value.length) {
      return value;
    }
    return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
  }

}
